<ng-container *ngTemplateOutlet="fromtraffics ? extern : all"></ng-container>

<ng-template #all>
    @if(inclusiveList?.length > 0) {
    <div class="tour-title-wrapper">
        <span multilang class="tour-title">{{'Inklusive Leistungen'}}</span>
    </div>

    <div class="tour-wrapper">
        <ng-container *ngFor="let op of inclusiveList | slice:0:slicenbr">
            <button class="tour-item-wrapper" (click)="selected(op)" matRipple>
                <mat-icon class="tour-item-icon ">{{selectedList.indexOf(op.code) >= 0 ? 'check_box' :
                    'check_box_outline_blank'}}</mat-icon>
                <span multilang class="tour-item-name">{{op.name}}</span>
            </button>
        </ng-container>
        <ng-container *ngIf="inclusiveList.length > 5">
            <ng-container *ngIf="(slicenbr < inclusiveList.length) else less">
                <button class="showallbtn" (click)="showMore(inclusiveList.length)" matRipple>
                    <span multilang>{{'alle'}} {{inclusiveList.length}} {{'anzeigen'}}</span>
                </button>
            </ng-container>
            <ng-template #less>
                <button class="showallbtn" (click)="showMore(5)" matRipple>
                    <span multilang>{{'weniger anzeigen'}}</span>
                </button>
            </ng-template>
        </ng-container>
    </div>
    }
</ng-template>

<ng-template #extern>
    @if(inclusiveList?.length > 0) {
    <div class="tour-title-wrapper">
        <span multilang class="tour-title">{{'Inklusive Leistungen'}}</span>
    </div>

    <div class="tour-wrapper">
        <ng-container *ngFor="let item of inclusiveList | slice:0:slicenbr">
            <button class="tour-item-wrapper-ext" (click)="selected(item)" matRipple>
                <mat-icon class="tour-item-icon ">{{selectedList.indexOf(item.code) >= 0 ? 'check_box' :
                    'check_box_outline_blank'}}</mat-icon>
                <div class="bestprc">
                    <span multilang class="tour-item-name-ext">{{item.name}}</span>
                    <span multilang class="bestprcit">{{'ab'}} {{item.bestPricePerPerson?.value + ' ' +
                        item.bestPricePerPerson?.currency}} p.P.</span>
                </div>
            </button>
        </ng-container>
        <ng-container *ngIf="inclusiveList.length > 5">
            <ng-container *ngIf="(slicenbr < inclusiveList.length) else less">
                <button class="showallbtn" (click)="showMore(inclusiveList.length)" matRipple>
                    <span multilang>{{'alle'}} {{inclusiveList.length}} {{'anzeigen'}}</span>
                </button>
            </ng-container>
            <ng-template #less>
                <button class="showallbtn" (click)="showMore(5)" matRipple>
                    <span multilang>{{'weniger anzeigen'}}</span>
                </button>
            </ng-template>
        </ng-container>
    </div>
    }
</ng-template>